export const FloaterButton = {
  container: {
    position: "fixed",
    bottom: 16,
    right: 16,
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "center",
    zIndex: 1,
  },

  actionButtonContainer: {
    flexDirection: "column" as const,
    gap: 1,
    marginBottom: 1,
    position: "absolute",
    bottom: 65,
    right: 0,
  },

  actionButton: (backgroundColor: string) => ({
    backgroundColor,
    color: "#fff",
    width: 200,
    justifyContent: "flex-start",
    textTransform: "none" as const,
    fontSize: "13px",
    fontWeight: "500",
    borderRadius: "10px",
    "&:hover": { backgroundColor },
  }),

  fab: {
    width: 56,
    height: 56,
  },

  paymentCardStyle: {
    display: "flex",
    alignItems: "center",
    height: "100%",
  },
};
